

















import Vue from 'vue';
export default Vue.extend({
  name: 'QuizDynamicHeightComponent',
  props: {
    value: {
      type: String,
      default: '',
    },
  },
});
